export const CallInsightsAgentDashboards = {
  CallInsightsAgentDashboards: {
    permissionsId: "43c1d67f-7db5-43bd-008b-08dd03ecea2b",
    permissionsName: "Call Insights Agent",
    description: null,
    componentsId: null,
    components: null,
  },
};
